import React, { useMemo, useState } from "react";
import { Alert, Button, Form, Modal, Spinner } from "react-bootstrap";
import api from "../../services/api";
import "./FluxopayRefundModal.css";

const money = value => Number(value || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

const idempotencyKey = () => {
  if (window.crypto?.randomUUID) {
    return window.crypto.randomUUID();
  }

  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx"
    .replace(/[xy]/g, character => {
      const random = Math.floor(
        Math.random() * 16
      );

      const value = character === "x"
        ? random
        : ((random & 3) | 8);

      return value.toString(16);
    });
};

export default function FluxopayRefundModal({ transaction, onClose, onCompleted }) {
  const [requestKey] = useState(idempotencyKey);
  const refundable = Math.max(0, Number(transaction.gross || 0) - Number(transaction.refunded || 0));
  const [type, setType] = useState("total");
  const [amount, setAmount] = useState(refundable.toFixed(2).replace(".", ","));
  const [reason, setReason] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const amountNumber = useMemo(() => Number(String(amount).replace(/\./g, "").replace(",", ".")) || 0, [amount]);

  const submit = async event => {
    event.preventDefault(); setSaving(true); setError("");
    try {
      await api.post(`/api/fluxopay/orders/${transaction.uuid}/refunds`, {
        amount_cents: type === "total" ? null : Math.round(amountNumber * 100),
        reason, password, confirm, idempotency_key: requestKey,
      });
      onCompleted?.(); onClose();
    } catch (requestError) {
      const response = requestError?.response?.data;
      setError(response?.message || response?.errors?.[0]?.description || "Não foi possível solicitar o estorno.");
    } finally { setSaving(false); }
  };

  return <Modal show onHide={saving ? undefined : onClose} centered size="lg">
    <Form onSubmit={submit}>
      <Modal.Header closeButton><Modal.Title>Solicitar estorno</Modal.Title></Modal.Header>
      <Modal.Body className="fxpay-refund">
        <Alert variant="info"><strong>Estorno é diferente de chargeback.</strong><br/>Esta ação é iniciada voluntariamente pela clínica. Uma contestação é iniciada pelo titular do cartão e continua sendo tratada na aba Contestações.</Alert>
        {error && <Alert variant="danger">{error}</Alert>}
        <div className="fxpay-refund__summary"><div><small>Cobrança</small><b>{transaction.id}</b></div><div><small>Valor original</small><b>{money(transaction.gross)}</b></div><div><small>Já estornado</small><b>{money(transaction.refunded)}</b></div><div><small>Disponível</small><b>{money(refundable)}</b></div></div>
        <Form.Group className="mb-3"><Form.Label>Tipo de estorno</Form.Label><div className="fxpay-refund__types"><Form.Check type="radio" name="refundType" label={`Total (${money(refundable)})`} checked={type === "total"} onChange={() => { setType("total"); setAmount(refundable.toFixed(2).replace(".", ",")); }} /><Form.Check type="radio" name="refundType" label="Parcial" checked={type === "partial"} onChange={() => setType("partial")} /></div></Form.Group>
        {type === "partial" && <Form.Group className="mb-3"><Form.Label>Valor a devolver</Form.Label><Form.Control value={amount} onChange={event => setAmount(event.target.value)} required /><Form.Text>Máximo disponível: {money(refundable)}</Form.Text></Form.Group>}
        <Form.Group className="mb-3"><Form.Label>Motivo do estorno</Form.Label><Form.Control as="textarea" rows={3} minLength={10} maxLength={500} value={reason} onChange={event => setReason(event.target.value)} placeholder="Descreva o motivo para auditoria e conciliação." required /></Form.Group>
        <Form.Group className="mb-3"><Form.Label>Senha atual do Representante Legal</Form.Label><Form.Control type="password" autoComplete="current-password" value={password} onChange={event => setPassword(event.target.value)} required /></Form.Group>
        <Form.Check checked={confirm} onChange={event => setConfirm(event.target.checked)} label={`Confirmo a devolução de ${money(type === "total" ? refundable : amountNumber)} ao pagador.`} required />
      </Modal.Body>
      <Modal.Footer><Button variant="light" onClick={onClose} disabled={saving}>Cancelar</Button><Button variant="danger" type="submit" disabled={saving || !confirm || reason.trim().length < 10 || (type === "partial" && (amountNumber <= 0 || amountNumber > refundable))}>{saving ? <><Spinner size="sm"/> Enviando ao Asaas...</> : "Solicitar estorno"}</Button></Modal.Footer>
    </Form>
  </Modal>;
}
